var _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRecurring = function SvgRecurring(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48.765625 48.765625",
    height: 48.765625,
    width: 48.765625,
    fill: "#8290A2",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,48.765625)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,26.894531)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 18.498226,-1.971383 C 17.167738,-1.880578 15.844473,-2.231414 14.733737,-2.96946 13.623001,-3.707506 12.786893,-4.791498 12.355135,-6.053255 12.057882,-6.92194 11.112704,-7.385176 10.24402,-7.087923 9.375337,-6.79067 8.9121,-5.845492 9.209352,-4.976808 c 0.668767,1.954383 1.963846,3.63342 3.684307,4.776608 1.72046,1.143186 3.770115,1.68661 5.83096,1.545958 2.060844,-0.140651 4.017658,-0.957515 5.566847,-2.323854 0.225731,-0.199088 0.440967,-0.40822 0.645206,-0.626513 v 0.269255 c 0,0.918135 0.744293,1.662429 1.662428,1.662429 0.918135,0 1.66243,-0.744294 1.66243,-1.662429 v -5.195164 c 0,-0.918134 -0.744295,-1.662429 -1.66243,-1.662429 h -0.907802 c -0.02133,-4.12e-4 -0.0426,-4.1e-4 -0.0638,0 h -4.223559 c -0.918132,0 -1.662429,0.744295 -1.662429,1.662429 0,0.918134 0.744297,1.66243 1.662429,1.66243 h 1.857563 c -0.315073,0.518333 -0.70829,0.98982 -1.169298,1.396416 -1.00016,0.882114 -2.263487,1.409484 -3.593975,1.500289 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,26.896484)",
    id: "g16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path18",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11.637005,-15.883764 v 0.272077 c 0.204683,-0.218839 0.420418,-0.428478 0.646695,-0.628023 1.548883,-1.3659 3.505168,-2.182587 5.565482,-2.323406 2.060316,-0.14082 4.10953,0.402094 5.829855,1.544548 1.720329,1.142452 3.015637,2.820606 3.685059,4.774216 0.297617,0.868559 -0.165219,1.813932 -1.033779,2.111553 -0.868559,0.297617 -1.813931,-0.16522 -2.11155,-1.033779 -0.432182,-1.261261 -1.268438,-2.344681 -2.379085,-3.082255 -1.110651,-0.737571 -2.433632,-1.088077 -3.763779,-0.997163 -1.330143,0.09091 -2.593128,0.618169 -3.593095,1.5 -0.460624,0.406206 -0.853579,0.877193 -1.168547,1.394968 h 1.85548 c 0.918132,0 1.662429,0.744295 1.662429,1.662429 0,0.918135 -0.744297,1.662428 -1.662429,1.662428 h -4.221865 c -0.02141,4.18e-4 -0.04289,4.22e-4 -0.06442,0 H 9.974581 c -0.918135,0 -1.662429,-0.744293 -1.662429,-1.662428 v -5.195165 c 0,-0.918133 0.744294,-1.662428 1.662429,-1.662428 0.918135,0 1.662429,0.744295 1.662429,1.662428 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path22",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 36.573444,18.287497 C 36.573444,8.188017 28.386202,7.74e-4 18.286722,7.74e-4 8.187244,7.74e-4 0,8.188017 0,18.287497 c 0,10.099477 8.187244,18.286722 18.286722,18.286722 10.09948,0 18.286722,-8.187245 18.286722,-18.286722 z m -3.324855,0 c 0,-8.263211 -6.698657,-14.961867 -14.961867,-14.961867 -8.263209,0 -14.961863,6.698656 -14.961863,14.961867 0,8.263208 6.698654,14.961862 14.961863,14.961862 8.26321,0 14.961867,-6.698654 14.961867,-14.961862 z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRecurring, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/recurring.3bbec5cf.svg";
export { ForwardRef as ReactComponent };